import spriteUrl from "../../img/sprite.svg";
import spriteClearUrl from "../../img/sprite-clr.svg";
/**
 * Спрайты подключаются через webpack, чтобы хэш содержимого был в имени файла (а не в query string): так URL и содержимое
 * всегда соответствуют друг другу. Сервер берёт те же URL из manifest.json (см. spriteUrl() в functions.php).
 */
export function spriteHref(id, clear) {
    if (clear === void 0) { clear = false; }
    return "".concat(clear ? spriteClearUrl : spriteUrl, "#").concat(id);
}
